'use client';

import { c as _c } from "react/compiler-runtime";
import './search-results.scss';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchBar } from '../../molecules/search-bar/search-bar.tsx';
import { usePaginationQueryParams, useSearchQueryParams } from '../../utils/query-params.tsx';
import { getLegacyQuery } from '../../utils/search.tsx';
import { SearchResultsList } from './search-results-list.tsx';
export const SearchResults = () => {
  const $ = _c(29);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["skippy"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    searchFilters,
    setSearchFilters
  } = useSearchQueryParams();
  const {
    currentPage,
    setCurrentPage
  } = usePaginationQueryParams();
  let t1;
  if ($[1] !== setCurrentPage) {
    t1 = p => {
      setCurrentPage(p);
    };
    $[1] = setCurrentPage;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handlePageChange = t1;
  let t2;
  if ($[3] !== setCurrentPage || $[4] !== setSearchFilters) {
    t2 = q => {
      setSearchFilters(q);
      setCurrentPage(0);
    };
    $[3] = setCurrentPage;
    $[4] = setSearchFilters;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleQueryChange = t2;
  let t3;
  if ($[6] !== handleQueryChange) {
    t3 = () => {
      const legacyQuery = getLegacyQuery();
      if (legacyQuery) {
        handleQueryChange(legacyQuery);
      }
    };
    $[6] = handleQueryChange;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== t) {
    t5 = t("skippy:siteSearch.searchResults");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("skippy:siteSearch.searchOurSite");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== handleQueryChange) {
    t7 = value => handleQueryChange(value);
    $[13] = handleQueryChange;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== searchFilters || $[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t8 = <SearchBar title={t5} titleSize="lg" placeholder={t6} onQueryChange={t7} defaultQuery={searchFilters} enableQuickSearch={true} />;
    $[15] = searchFilters;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== handlePageChange) {
    t9 = page => handlePageChange(page);
    $[20] = handlePageChange;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== currentPage || $[23] !== searchFilters || $[24] !== t9) {
    t10 = <SearchResultsList queryText={searchFilters} itemsPerPage={10} currentPage={currentPage} onPageChange={t9} />;
    $[22] = currentPage;
    $[23] = searchFilters;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t8) {
    t11 = <section className="SearchResults component"><div className="SearchResults__container container">{t8}{t10}</div></section>;
    $[26] = t10;
    $[27] = t8;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
};